// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Countries, {getDefaultState as getCountriesDefaultState} from './countries';
import PrimaryProductStatuses, {getDefaultState as getPrimaryProductStatusesDefaultState} from './primary-product-statuses';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import StatesInCountry, {getDefaultState as getStatesInCountryDefaultState} from './states-in-country';
import StatusChangeRequest, {getDefaultState as getStatusChangeRequestDefaultState} from './status-change-request';
import StatusChangeRequestForm, {getDefaultState as getStatusChangeRequestFormDefaultState} from './status-change-request-form';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    countries: Countries,
    primaryProductStatuses: PrimaryProductStatuses,
    product: Product,
    statesInCountry: StatesInCountry,
    statusChangeRequest: StatusChangeRequest,
    statusChangeRequestForm: StatusChangeRequestForm
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        countries: getCountriesDefaultState(),
        primaryProductStatuses: getPrimaryProductStatusesDefaultState(),
        product: getProductDefaultState(),
        statesInCountry: getStatesInCountryDefaultState(),
        statusChangeRequest: getStatusChangeRequestDefaultState(),
        statusChangeRequestForm: getStatusChangeRequestFormDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/status-change-request/state/index.js